import React, { Component, Button } from 'react';
import Accordion from 'react-bootstrap/Accordion';
import { Card } from "react-bootstrap";

export class Impressum extends Component {
    render() {
        return (
            <div id="impressum">
                <div className="section-title">
                    <Accordion defaultActiveKey="1">
                        <Card>
                            <Card.Header>
                                <Accordion.Toggle className="btn btn-custom btn-lg btn-events" as={Button} variant="link" eventKey="0"> Impressum</Accordion.Toggle>
                            </Card.Header>
                            <Accordion.Collapse eventKey="0">
                                <p>
                                    Julianne und Roland Alton<br />
                                                    Badgasse 3 <br />
                                                    6850 Dornbirn <br /><br />
                                                    Website entstanden im Rahmen des Kontextmoduls „Online Kampagnen gestalten“ <br />
                                                    Studierende: Laura Holzer; Valérie Peter; Johanna Strobl <br />
                                                    Lehrbeauftragte:<br /><br />
                                                    Roland Alton, Marc Rogenmoser, Christian Fischer<br />
                                                    Angaben gemäß § 25 Mediengesetz und Information gemäß § 5 E-Commerce-Gesetz
                                                </p>
                            </Accordion.Collapse>
                        </Card>
                    </Accordion>
                </div>
            </div>
        );
    }
}

export default Impressum;
